// removed by extract-text-webpack-plugin
module.exports = {"vpVideoDownloadButton":"vpVideoDownloadButton___2GJ4y","vpDownloadIcon":"vpDownloadIcon___95Gjm","vpInputDisabled":"vpInputDisabled___3HhLS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/DownloadButton.module.less
// module id = 3503
// module chunks = 33